export default __webpack_public_path__ + "static/custom-logo-2-02dcec5137a4ab7f6dc329851e5dd79e.webp";